<div class="flex justify-content-end mb-4">
  <p-dropdown [options]="dataSets" [(ngModel)]="selectedDataset" placeholder="Language" optionLabel="label"
    (onChange)="onDatasetChanged($event)">
  </p-dropdown>
</div>
<p-table [value]="selectedAxialLengthData" class="" [styleClass]="'p-datatable-sm'">
  <ng-template pTemplate="header">
    <tr>
      <th>Age</th>
      <th>Expected eye growth [mm/year]</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-axialLengthRow>
    <tr>
      <td>{{ axialLengthRow.age }}</td>
      <td>{{ axialLengthRow.expectedEyeGrowth }}</td>
    </tr>
  </ng-template>
</p-table>